export var BUTTON_FOREGROUND = '#3D8ECD';
export var BUTTON_BACKGROUND = 'white';
export var ERROR_COLOR = '#C82C41';